// Here is stuff that is shared front and backend
// Well some of it is just front end but since it is all realted I put it here anyway,

export const sharedConfig = {
  enableLocalSW: false,
  securityTiming: {
    miniumumSecurityTime: 1000 * 60, // The minimum time that any security period can be set to
    userSettingsSecurityTimeOut: 1000 * 60 * 30, // Setting security security will timeout after this time
    activityCheckDebounce: 5 * 1000, // Limit the rate of activity calls to the backend.
    nudgeIfAboutToExpireTime: 30 * 1000, // Nudge the user if the security is about to expire (must be less than miniumumSecurityTime)
    securityPollInterval: 5 * 1000, // The rate at which we check to see if the security is about to expire (must be less than miniumumSecurityTime)
    addToFrontendNow: 10 * 1000, // Add to the frontend now (must be greater than securityPollInterval)
    NOEXPIRETIME: 100 * 24 * 60 * 60 * 1000, // This is used to indicate that the security will not expire
    UNDEFINEDTIME: -1, // This is used to indicate that has not got a recorded time
  },
};
